var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "6px",
    viewBox: "0 0 9 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Merchants",
    transform: "translate(-1397.000000, -38.000000)",
    fill: "current",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(1340.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    points: "64.9464408 5 66 6.13825293 61.5 11 57 6.13825293 58.0535592 5 61.5 8.72312946"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrowDown);
export default __webpack_public_path__ + "static/media/smallArrowDown.b67ad930bd552d57c3e541a85a6fa5d8.svg";
export { ForwardRef as ReactComponent };